import { ExportModalFilesList } from '../../../Table'

function DirectLinks({
  exportLinkTitleKey = 'Common.ModalExportDownloadFileTextKey',
  filesIds,
}) {
  return (
    <ExportModalFilesList
      exportLinkTitleKey={exportLinkTitleKey}
      items={filesIds}
    />
  )
}

export default DirectLinks
